export const dxHtmlEditorMessages = {
    'pt-BR': {
      'dxHtmlEditor-undo': 'Desfazer',
      'dxHtmlEditor-redo': 'Refazer',
      'dxHtmlEditor-bold': 'Negrito',
      'dxHtmlEditor-italic': 'Itálico',
      'dxHtmlEditor-strike': 'Tachado',
      'dxHtmlEditor-underline': 'Sublinhado',
      'dxHtmlEditor-alignLeft': 'Alinhar à esquerda',
      'dxHtmlEditor-alignCenter': 'Centralizar',
      'dxHtmlEditor-alignRight': 'Alinhar à direita',
      'dxHtmlEditor-alignJustify': 'Justificar',
      'dxHtmlEditor-orderedList': 'Lista numerada',
      'dxHtmlEditor-bulletList': 'Lista com marcadores',
      'dxHtmlEditor-decreaseIndent': 'Diminuir recuo',
      'dxHtmlEditor-increaseIndent': 'Aumentar recuo',
      'dxHtmlEditor-link': 'Inserir link',
      'dxHtmlEditor-image': 'Inserir imagem',
      'dxHtmlEditor-color': 'Cor da fonte',
      'dxHtmlEditor-background': 'Cor de fundo',
      'dxHtmlEditor-clear': 'Limpar formatação',
      'dxHtmlEditor-codeBlock': 'Bloco de código',
      'dxHtmlEditor-blockquote': 'Citação',
      'dxHtmlEditor-header': 'Cabeçalho',
      'dxHtmlEditor-size': 'Tamanho',
      'dxHtmlEditor-font': 'Fonte',
      'dxHtmlEditor-dialogColorCaption': 'Alterar cor da fonte',
      'dxHtmlEditor-dialogBackgroundCaption': 'Alterar cor de fundo',
      'dxHtmlEditor-dialogLinkCaption': 'Adicionar Link',
      'dxHtmlEditor-dialogLinkUrlField': 'URL',
      'dxHtmlEditor-dialogLinkTextField': 'Texto',
      'dxHtmlEditor-dialogLinkTargetField': 'Abrir em nova janela',
      'dxHtmlEditor-dialogImageCaption': 'Adicionar Imagem',
      'dxHtmlEditor-dialogImageUrlField': 'URL da Imagem',
      'dxHtmlEditor-dialogImageAltField': 'Texto Alternativo',
      'dxHtmlEditor-dialogImageWidthField': 'Largura',
      'dxHtmlEditor-dialogImageHeightField': 'Altura',
      'dxHtmlEditor-heading': 'Cabeçalho',
      'dxHtmlEditor-normal': 'Normal',
      'dxHtmlEditor-normalText': 'Texto Normal',
      'dxHtmlEditor-imageUploadingError': 'Erro ao carregar imagem',
      'dxHtmlEditor-imageUploadingMaxFileSizeError': 'Arquivo muito grande',
      'dxHtmlEditor-dialogImageSelectFile': 'Deste Dispositivo',
      'dxHtmlEditor-dialogImageSpecifyUrl': 'Da Web',
      'dxHtmlEditor-dialogImageEncodeToBase64': 'Codificar em Base64',
      'dxHtmlEditor-dialogImageAddButton': 'Adicionar',
      'dxHtmlEditor-dialogImageCancelButton': 'Cancelar',
      'dxHtmlEditor-dialogImageKeepAspectRatio': 'Manter Proporção',
    },
    'en-US': {
      'dxHtmlEditor-undo': 'Undo',
      'dxHtmlEditor-redo': 'Redo',
      'dxHtmlEditor-bold': 'Bold',
      'dxHtmlEditor-italic': 'Italic',
      'dxHtmlEditor-strike': 'Strikethrough',
      'dxHtmlEditor-underline': 'Underline',
      'dxHtmlEditor-alignLeft': 'Align Left',
      'dxHtmlEditor-alignCenter': 'Align Center',
      'dxHtmlEditor-alignRight': 'Align Right',
      'dxHtmlEditor-alignJustify': 'Justify',
      'dxHtmlEditor-orderedList': 'Ordered List',
      'dxHtmlEditor-bulletList': 'Bullet List',
      'dxHtmlEditor-decreaseIndent': 'Decrease Indent',
      'dxHtmlEditor-increaseIndent': 'Increase Indent',
      'dxHtmlEditor-link': 'Insert Link',
      'dxHtmlEditor-image': 'Insert Image',
      'dxHtmlEditor-color': 'Font Color',
      'dxHtmlEditor-background': 'Background Color',
      'dxHtmlEditor-clear': 'Clear Formatting',
      'dxHtmlEditor-codeBlock': 'Code Block',
      'dxHtmlEditor-blockquote': 'Blockquote',
      'dxHtmlEditor-header': 'Header',
      'dxHtmlEditor-size': 'Size',
      'dxHtmlEditor-font': 'Font',
      'dxHtmlEditor-dialogColorCaption': 'Change Font Color',
      'dxHtmlEditor-dialogBackgroundCaption': 'Change Background Color',
      'dxHtmlEditor-dialogLinkCaption': 'Add Link',
      'dxHtmlEditor-dialogLinkUrlField': 'URL',
      'dxHtmlEditor-dialogLinkTextField': 'Text',
      'dxHtmlEditor-dialogLinkTargetField': 'Open in New Window',
      'dxHtmlEditor-dialogImageCaption': 'Add Image',
      'dxHtmlEditor-dialogImageUrlField': 'Image URL',
      'dxHtmlEditor-dialogImageAltField': 'Alternative Text',
      'dxHtmlEditor-dialogImageWidthField': 'Width',
      'dxHtmlEditor-dialogImageHeightField': 'Height',
      'dxHtmlEditor-heading': 'Header',
      'dxHtmlEditor-normal': 'Normal',
      'dxHtmlEditor-normalText': 'Normal Text',
      'dxHtmlEditor-imageUploadingError': 'Error uploading image',
      'dxHtmlEditor-imageUploadingMaxFileSizeError': 'File too large',
      'dxHtmlEditor-dialogImageSpecifyUrl': 'From the Web',
      'dxHtmlEditor-dialogImageEncodeToBase64': 'Encode to Base64',
      'dxHtmlEditor-dialogImageAddButton': 'Add',
      'dxHtmlEditor-dialogImageCancelButton': 'Cancel',
      'dxHtmlEditor-dialogImageKeepAspectRatio': 'Keep Aspect Ratio',
      'dxFileUploader-upload': 'Upload',
    },
    'es-ES': {
      'dxHtmlEditor-undo': 'Deshacer',
      'dxHtmlEditor-redo': 'Rehacer',
      'dxHtmlEditor-bold': 'Negrita',
      'dxHtmlEditor-italic': 'Cursiva',
      'dxHtmlEditor-strike': 'Tachado',
      'dxHtmlEditor-underline': 'Subrayado',
      'dxHtmlEditor-alignLeft': 'Alinear a la izquierda',
      'dxHtmlEditor-alignCenter': 'Centrar',
      'dxHtmlEditor-alignRight': 'Alinear a la derecha',
      'dxHtmlEditor-alignJustify': 'Justificar',
      'dxHtmlEditor-orderedList': 'Lista numerada',
      'dxHtmlEditor-bulletList': 'Lista con viñetas',
      'dxHtmlEditor-decreaseIndent': 'Disminuir sangría',
      'dxHtmlEditor-increaseIndent': 'Aumentar sangría',
      'dxHtmlEditor-link': 'Insertar enlace',
      'dxHtmlEditor-image': 'Insertar imagen',
      'dxHtmlEditor-color': 'Color de fuente',
      'dxHtmlEditor-background': 'Color de fondo',
      'dxHtmlEditor-clear': 'Limpiar formato',
      'dxHtmlEditor-codeBlock': 'Bloque de código',
      'dxHtmlEditor-blockquote': 'Cita',
      'dxHtmlEditor-header': 'Encabezado',
      'dxHtmlEditor-size': 'Tamaño',
      'dxHtmlEditor-font': 'Fuente',
      'dxHtmlEditor-dialogColorCaption': 'Cambiar color de fuente',
      'dxHtmlEditor-dialogBackgroundCaption': 'Cambiar color de fondo',
      'dxHtmlEditor-dialogLinkCaption': 'Añadir enlace',
      'dxHtmlEditor-dialogLinkUrlField': 'URL',
      'dxHtmlEditor-dialogLinkTextField': 'Texto',
      'dxHtmlEditor-dialogLinkTargetField': 'Abrir en nueva ventana',
      'dxHtmlEditor-dialogImageCaption': 'Añadir imagen',
      'dxHtmlEditor-dialogImageUrlField': 'URL de la imagen',
      'dxHtmlEditor-dialogImageAltField': 'Texto alternativo',
      'dxHtmlEditor-dialogImageWidthField': 'Ancho',
      'dxHtmlEditor-dialogImageHeightField': 'Alto',
      'dxHtmlEditor-heading': 'Encabezado',
      'dxHtmlEditor-normal': 'Normal',
      'dxHtmlEditor-normalText': 'Texto normal',
      'dxHtmlEditor-imageUploadingError': 'Error al cargar la imagen',
      'dxHtmlEditor-imageUploadingMaxFileSizeError': 'Archivo demasiado grande',
      'dxHtmlEditor-dialogImageSpecifyUrl': 'Desde la web',
      'dxHtmlEditor-dialogImageEncodeToBase64': 'Codificar en Base64',
      'dxHtmlEditor-dialogImageAddButton': 'Añadir',
      'dxHtmlEditor-dialogImageCancelButton': 'Cancelar',
      'dxHtmlEditor-dialogImageKeepAspectRatio': 'Mantener proporción',
      'dxFileUploader-upload': 'Subir',
    }
};